/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
import React, { useEffect, useRef } from 'react';
import { Stream } from '@cloudflare/stream-react';
import { videoLinkParser } from '../utils/utils';

interface IVideoPlayer {
  videoUrl: string;
  autoPlay?: boolean;
  shouldStopVideo?: boolean
}

export const VideoPlayer = ({ videoUrl, autoPlay = false, shouldStopVideo = false }: IVideoPlayer):JSX.Element => {
  const videoLink = videoLinkParser(videoUrl);
  const shouldAutoPlay = autoPlay || document.documentElement.getAttribute('data-custom') === 'ezy-math-tutoring';
  const src = useRef('');
  const stopVideo = () => {
    const iframe = document.querySelector('iframe[title="iframePlayer"]') as HTMLIFrameElement;
    const video = document.querySelector('video');
    if (iframe) {
      const iframeSrc = iframe.src;
      iframe.src = iframeSrc;
    }
    if (video) {
      video.pause();
    }
  };

  useEffect(() => {
    if (shouldStopVideo) {
      stopVideo();
    }
  }, [shouldStopVideo]);
  if (videoLink.youtubeLink || videoLink.vimeoLink) {
    src.current = videoLink.youtubeLink
      ? `https://www.youtube.com/embed/${videoLink.youtubeLink}?rel=0&modestbranding=1&showinfo=0${shouldAutoPlay ? '&autoplay=1&mute=1' : ''}`
      : `https://player.vimeo.com/video/${videoLink.vimeoLink}${shouldAutoPlay ? '?autoplay=1&muted=1' : ''}`;
    return (
      <iframe
        title="iframePlayer"
        src={src.current}
        style={{
          border: 'none', position: 'absolute', top: 0, height: '100%', width: '100%',
        }}
        allow="accelerometer; gyroscope; autoplay; encrypted-media;"
        allowFullScreen
      />
    );
  }
  if (videoLink.cloudFlareLink) {
    return (
      <Stream controls src={videoLink.cloudFlareLink} autoplay={shouldAutoPlay} muted={shouldAutoPlay} />
    );
  }
  const videoSrc = (videoLink.dropboxLink)
    ? videoLink.dropboxLink.replace('dl=0', 'raw=1') : videoLink.videoLink;
  return (
  // eslint-disable-next-line jsx-a11y/media-has-caption
    <video
      src={videoSrc}
      controls
      preload="true"
      autoPlay={shouldAutoPlay}
      muted={shouldAutoPlay}
      playsInline
      disablePictureInPicture
      controlsList="nodownload"
    />
  );
};
